const adminTokenKey = 'admin_token';
const adminUserKey = 'admin_user';

const participantTokenKey = (sessionId: string) => `participant_token_${sessionId}`;
const participantNameKey = (sessionId: string) => `participant_name_${sessionId}`;
const spectatorTokenKey = (sessionId: string) => `spectator_token_${sessionId}`;
const bookingTokenKey = 'booking_intern_token';

export const adminSessionStorage = {
  getToken(): string | null {
    return typeof window === 'undefined' ? null : localStorage.getItem(adminTokenKey);
  },
  setToken(token: string): void {
    localStorage.setItem(adminTokenKey, token);
  },
  clear(): void {
    localStorage.removeItem(adminTokenKey);
    localStorage.removeItem(adminUserKey);
  },
  setUser(user: unknown): void {
    localStorage.setItem(adminUserKey, JSON.stringify(user));
  },
};

export const participantSessionStorage = {
  getToken(sessionId: string): string | null {
    return typeof window === 'undefined' ? null : localStorage.getItem(participantTokenKey(sessionId));
  },
  setToken(sessionId: string, token: string): void {
    localStorage.setItem(participantTokenKey(sessionId), token);
  },
  clear(sessionId: string): void {
    localStorage.removeItem(participantTokenKey(sessionId));
    localStorage.removeItem(participantNameKey(sessionId));
  },
  setPlayerName(sessionId: string, name: string): void {
    localStorage.setItem(participantNameKey(sessionId), name);
  },
  getPlayerName(sessionId: string): string | null {
    return typeof window === 'undefined' ? null : localStorage.getItem(participantNameKey(sessionId));
  },
};

export const spectatorSessionStorage = {
  getToken(sessionId: string): string | null {
    return typeof window === 'undefined' ? null : localStorage.getItem(spectatorTokenKey(sessionId));
  },
  setToken(sessionId: string, token: string): void {
    localStorage.setItem(spectatorTokenKey(sessionId), token);
  },
  clear(sessionId: string): void {
    localStorage.removeItem(spectatorTokenKey(sessionId));
  },
};

export const bookingSessionStorage = {
  getToken(): string | null {
    return typeof window === 'undefined' ? null : localStorage.getItem(bookingTokenKey);
  },
  setToken(token: string): void {
    localStorage.setItem(bookingTokenKey, token);
  },
  clear(): void {
    localStorage.removeItem(bookingTokenKey);
  },
};

const writtenParticipantTokenKey = (sessionId: string) => `written_participant_token_${sessionId}`;
const writtenParticipantNameKey = (sessionId: string) => `written_participant_name_${sessionId}`;

export const writtenParticipantSessionStorage = {
  getToken(sessionId: string): string | null {
    return typeof window === 'undefined' ? null : localStorage.getItem(writtenParticipantTokenKey(sessionId));
  },
  setToken(sessionId: string, token: string): void {
    localStorage.setItem(writtenParticipantTokenKey(sessionId), token);
  },
  clear(sessionId: string): void {
    localStorage.removeItem(writtenParticipantTokenKey(sessionId));
    localStorage.removeItem(writtenParticipantNameKey(sessionId));
  },
  setPlayerName(sessionId: string, name: string): void {
    localStorage.setItem(writtenParticipantNameKey(sessionId), name);
  },
  getPlayerName(sessionId: string): string | null {
    return typeof window === 'undefined' ? null : localStorage.getItem(writtenParticipantNameKey(sessionId));
  },
};
